export default __webpack_public_path__ + "locales/bg/UploadPanel.json?hash=8e08ccf34a385455c2224311b3d8cf0f";